export const obtenerValorSaldo = ({totalReserva, adicionales, descuentos, abonos}) =>{

    let total = totalReserva
    let valorAdicionales = adicionales ? totalArr(adicionales) : 0
    let valorDescuentos = descuentos ? totalArr(descuentos) : 0
    let valorAbonos = abonos ? totalArr(abonos) : 0


    return total + valorAdicionales - valorDescuentos - valorAbonos;

}

export const totalArr = (arr=[]) => {

    let total = 0
    for (let i = 0; i < arr.length; i++) {
        total += parseInt(arr[i].valor)
    }

    return total
}